import { Component, OnInit } from '@angular/core';
import { EditForm } from '../../../../base/controlers/edit-form';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Decor, DecorItem } from '../../models/decor';
import { DecorService } from '../../services/decor.service';
import { IFileStoreItem } from '../../../../documents/interfaces/IFileStoreItem';
import { DecorType } from '../../models/decor-type';
import { DecorTypeService } from '../../services/decor-type.service';
import { TranslateService } from '@ngx-translate/core';
import { MatTableDataSource } from '@angular/material';
import { ItemService } from '../../services/item-service.service';
import { AfterNew } from '../../../../interfaces/iedit-form';

@Component({
  selector: 'app-decor',
  templateUrl: './decor.component.html',
  styleUrls: ['./decor.component.css']
})
export class DecorComponent extends EditForm<Decor> implements OnInit, AfterNew<Decor> {

  decorTypes: DecorType[];
  items = this.fb.array([]);
  public dataSource: MatTableDataSource<any>;
  public itemColumns: string[] =  ['actions','name','quantity','price'];
  private selectedItem:any;  
  constructor(
    ns: ToastrService,          
    tr: TranslateService,
    r: Router,
    ds:DecorService,
    ar: ActivatedRoute,
    l:Location,            
    private decorTypeService:DecorTypeService,
    protected itemService: ItemService,
    private fb: FormBuilder
  ) { 
    super(ns,tr,r,ds,ar,l,'/plasard-measurement/decor');    
  }

  ngOnInit() {
    this.form = new FormGroup({
      id: new FormControl(),
      code: new FormControl(),
      name: new FormControl(),
      itemPrice: new FormControl(0),
      newItem: new FormControl(null),
      plasardDecorTypeId: new FormControl(),
      picture: new FormControl(),
      items: this.items
    });
    super.ngOnInit();        
    this.decorTypeService.GetAll().subscribe((data)=>{
      if(data){
        this.decorTypes = data.payload;
      }
    })
  }
  onAterNew(model: Decor): Decor {
    
    if(!model.items){
      model.items = [];
    }
    return model;
  }   
  onFileUpload(file:IFileStoreItem){
    if(file){
      this.form.controls['picture'].setValue(file.id);
    }
    else {
      this.form.controls['picture'].setValue(null);
    }
  }
  onItemSelected(item:any){
    console.log('onItemSelected', item);
    this.selectedItem = item;
  }
  onAfterFormPopulated() {      
    if(this.currentData.items){
      this.dataSource = new MatTableDataSource(this.currentData.items);
      this.currentData.items.forEach(item=>{        
        this.items.push(this.initItem(item));
      })
    }
  }
  initItem(data?:DecorItem): FormGroup{

    if(data){
      return this.fb.group({
        id: new FormControl(data.id||'00000000-0000-0000-0000-000000000000'),
        decorId:new FormControl(data.decorId),
        itemId: new FormControl(data.itemId, Validators.required),        
        name: new FormControl(data.name, Validators.required),
        quantity: new FormControl(data.quantity),
        price: new FormControl(data.price),
        priceInternal: new FormControl(data.priceInternal),
        amount: new FormControl(data.amount),
        amountInternal: new FormControl(data.amountInternal)
             });
    }
    else{
      return this.fb.group({
        id: new FormControl('00000000-0000-0000-0000-000000000000'),
        decorId: new FormControl(null),
        itemId: new FormControl(null, Validators.required),
        name: new FormControl(null, Validators.required),
        quantity: new FormControl(null),
        price: new FormControl(null),
        priceInternal: new FormControl(null),
        amount: new FormControl(0),
        amountInternal: new FormControl(0)
             });
    }
  }
  addItem(){
    
    if(this.selectedItem){
      this.itemService.Get(this.selectedItem.id).subscribe(result => {
        if(result){
          let row:DecorItem = new DecorItem();
          row.decorId = this.id;
          row.itemId = result.payload.id;
          row.name = result.payload.name;
          row.quantity = 1;
          row.price = result.payload.price;
          row.priceInternal = result.payload.priceInternal;
          row.amount = 0;
          row.amountInternal = 0;

          this.items.push(this.initItem(row));
          const data = this.dataSource.data;
          data.push(row);  //add the new model object to the dataSource
          this.dataSource.data = data;          
          this.clearSelector();
        }
      })
    }    
  }

  deleteItem(idx:number){
    if (idx > -1) {
      this.items.removeAt(idx);
      let data = this.dataSource.data;
      data.splice(idx,1);      
      this.dataSource.data = data;
    }     
  }
  clearSelector(){
    const item = this.form.get('newItem');
    if(item){
      item.setValue(null);
    }
  }    
}
